export async function redirectToSso() {
  window.location.href = '/sso';
  await new Promise(() => {}) /* wait for redirect */;
}
